const state = () => ({
  seconds: 0,
  timer: null,
});

const mutations = {
  SET_TIMER(state, timer) {
    state.timer = timer;
    console.log("configurando um novo timer: " + timer);
  },
  INCREMENT_SECONDS(state) {
    state.seconds++;
  },
  RESET_SECONDS(state) {
    state.seconds = 0;
  },
  CLEAR_TIMER(state) {
    clearInterval(state.timer);
    state.timer = null;
    state.seconds = 0;
  },
};

const actions = {
  startTimer({ commit, state }) {
    // Evita múltiplos timers
    if (state.timer) return;

    const timer = setInterval(() => {
      commit("INCREMENT_SECONDS");
    }, 1000);

    commit("SET_TIMER", timer);
  },

  stopTimer({ commit }) {
    commit("CLEAR_TIMER");
  },

  resetTimer({ dispatch, commit }) {
    dispatch("stopTimer");
    commit("RESET_SECONDS");
  },
};

const getters = {
  seconds: (state) => state.seconds,
  formattedTime: (state) => {
    const min = String(Math.floor(state.seconds / 60)).padStart(2, "0");
    const sec = String(state.seconds % 60).padStart(2, "0");
    return `${min}:${sec}`;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
